import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TCacheRefreshResponsePayload,
	TDashboardServicesResponsePayload,
	TDashboardStore,
} from './types';
// ==========================================:
export const initialState: TDashboardStore = {
	totalTaxes: null,
	totalTaxesLoader: false,
	salesInfo: null,
	salesInfoLoader: false,
	monthlySalesInfo: null,
	monthlySalesInfoLoader: false,
	dashboardServices: null,
	dashboardServicesLoader: false,
};

// ==========================================:
const dashboard = createSlice({
	name: '@@dashboard',
	initialState,
	reducers: {
		getCacheRefreshRequest: (state: TDashboardStore) => {
			const dashboardState = state;
			dashboardState.totalTaxesLoader = true;
			dashboardState.salesInfoLoader = true;
			dashboardState.monthlySalesInfoLoader = true;
		},
		getCacheRefreshSuccess: (
			state: TDashboardStore,
			action: PayloadAction<TCacheRefreshResponsePayload>,
		) => {
			const { payload } = action;
			const dashboardState = state;
			dashboardState.totalTaxes = payload.totalTaxes;
			dashboardState.totalTaxesLoader = false;
			dashboardState.salesInfo = payload.salesInfo;
			dashboardState.salesInfoLoader = false;
			dashboardState.monthlySalesInfo = payload.monthlySalesInfo;
			dashboardState.monthlySalesInfoLoader = false;
		},
		getDashboardServicesRequest: (state: TDashboardStore) => {
			const dashboardState = state;
			dashboardState.dashboardServicesLoader = true;
		},
		getDashboardServicesSuccess: (
			state: TDashboardStore,
			action: PayloadAction<TDashboardServicesResponsePayload>,
		) => {
			const { payload } = action;
			const dashboardState = state;
			dashboardState.dashboardServices = payload;
			dashboardState.dashboardServicesLoader = false;
		},

		assetsInitState: () => initialState,
	},
});

export default dashboard.reducer;
export const {
	getCacheRefreshRequest,
	getCacheRefreshSuccess,
	getDashboardServicesRequest,
	getDashboardServicesSuccess,
	assetsInitState,
} = dashboard.actions;
